import { render, staticRenderFns } from "./tendersStatTable.vue?vue&type=template&id=51723b03&scoped=true&"
import script from "./tendersStatTable.vue?vue&type=script&lang=js&"
export * from "./tendersStatTable.vue?vue&type=script&lang=js&"
import style0 from "./tendersStatTable.vue?vue&type=style&index=0&id=51723b03&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51723b03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51723b03')) {
      api.createRecord('51723b03', component.options)
    } else {
      api.reload('51723b03', component.options)
    }
    module.hot.accept("./tendersStatTable.vue?vue&type=template&id=51723b03&scoped=true&", function () {
      api.rerender('51723b03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/tenders/tendersStatTable.vue"
export default component.exports